import {combineReducers} from "redux";

import AuthReducer from "./Reducers/AuthReducer";
import DrawerReducer from "./Reducers/DrawerReducer";
import CommunityReducer from "./Reducers/CommunityComments";
import LikedReducer from "./Reducers/LikedCommentReducer";
import QuestionListReducer from "./Reducers/QuestionListReducer";
import QuestionReducer from "./Reducers/QuestionReducer";
import GuideSlice from "./Reducers/GuideSlice";
import StripePublicKeySlice from "./Reducers/StripePublicKeySlice";
import LanguageSlice from "./Reducers/language-slice";
import buyMembershipSlice from "./Reducers/buy-membership-slice";


const rootReducer = combineReducers({
    DrawerReducer,
    AuthReducer,
    CommunityReducer,
    LikedReducer,
    QuestionListReducer,
    QuestionReducer,
    GuideSlice,
    StripePublicKeySlice,
    LanguageSlice,
    buyMembershipSlice
})


export default rootReducer;
